import React from 'react';
import AdobePluginInstallInstructions from './adobe-plugin';

export default function InDesignInstallInstructions() {
  return (
    <AdobePluginInstallInstructions
      productName="Adobe InDesign"
      ccxHref="/creative-indesign-plugin/indesign.ccx"
      downloadFileName="StreamWork InDesign Plugin.ccx"
      openMenuPath={<strong>Plug-Ins &gt; Streamwork &gt; Streamwork</strong>}
    />
  );
}
